import { Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Button } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { IGateway } from "../../../models/IGateway";

export type IUpdateGatewayDialogProps = {
    openDialog: boolean;
    handleClose: () => void;
    gateway: IGateway;
    handleUpdateGateway: (gatewayId: string, name: string, description: string | null) => void;
};

export default function UpdateGatewayDialog({ openDialog, handleClose, gateway, handleUpdateGateway }: IUpdateGatewayDialogProps) {
    const { handleSubmit, control } = useForm();

    function onSubmit(data: any) {
        handleUpdateGateway(gateway.id, data.name, data.description);
        handleClose();
    }

    const handleUpdateDialogClose: (event: any, reason: any) => void = (event, reason) => {
        if (reason && reason === "backdropClick") {
            return;
        }

        handleClose();
    };

    return (
        <Dialog
            open={openDialog}
            onClose={handleUpdateDialogClose}
        >
            <form noValidate onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>Edit Gateway</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Change the following fields to update the gateway
                    </DialogContentText>

                    <Controller
                        name="name"
                        control={control}
                        defaultValue={gateway.name}
                        rules={{
                            required: "This field is required"
                        }}
                        render={({ field: { onChange, value }, fieldState: { invalid, error } }) => (
                            <TextField
                                margin="normal"
                                label="Name"
                                type="text"
                                fullWidth
                                variant="outlined"
                                required
                                value={value}
                                onChange={onChange}
                                error={invalid}
                                helperText={error ? error.message : ""}
                            />
                        )}
                    />

                    <Controller
                        name="description"
                        control={control}
                        defaultValue={gateway.description}
                        render={({ field: { onChange, value }, fieldState: { invalid, error } }) => (
                            <TextField
                                margin="normal"
                                label="Description (Optional)"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={value}
                                onChange={onChange}
                                error={invalid}
                                helperText={error ? error.message : ""}
                            />
                        )}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleUpdateDialogClose(null, null)} variant="outlined">Cancel</Button>
                    <Button type="submit" variant="outlined">Update</Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}